import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import MonitoringSparkGraph from "components/Monitoring/MonitoringSparkGraph";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

import { AIBLE_VIEW_TYPE } from "containers/Project/reducer";

class MonitoringSparkGraphContainer extends React.Component {
  render() {
    return <MonitoringSparkGraph {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  const monitor = monitoringReducer.getMonitor(state, ownProps.id);
  const selectedRunId = projectReducer.getRunId(state, ownProps.id);
  const segmentId =
    ownProps.segmentId !== undefined ? ownProps.segmentId : projectReducer.getSegmentId(state, ownProps.id);
  const runId = projectReducer.getSegmentRunId(state, ownProps.id, segmentId);
  return {
    isContinuous: projectReducer.getIsContinuous(state, ownProps.id),
    latestScenario: monitoringReducer.getLatestScenarios(state, ownProps.id),
    latestData: monitoringReducer.getLatestData(state, ownProps.id),
    monitoringData: monitoringReducer.getData(state, ownProps.id),
    segmentId: segmentId,
    setupLabels: setupReducer.getSetupLabels(state, runId),
    scenarioIndex: getIsMonitoringDemo() ? projectReducer.getViewingScenarioIndex(state, ownProps.id) : undefined
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MonitoringSparkGraphContainer);
